import { Head, useForm } from '@inertiajs/react'
import { AuthShell } from '@/components/auth/AuthShell'
import { Button, Field, Label, Input, ErrorMessage } from '@/components/ui'
import { useTranslations } from '@/lib/i18n'

interface AcceptInvitationProps {
  invitation_token: string
  errors: Record<string, string>
}

export default function AcceptInvitation({ invitation_token, errors }: AcceptInvitationProps) {
  const { t } = useTranslations()
  const form = useForm({
    invitation_token,
    password: '',
    password_confirmation: '',
  })

  function submit(event: React.FormEvent) {
    event.preventDefault()
    form.transform((data) => ({ user: data }))
    form.put('/users/invitation')
  }

  return (
    <AuthShell title={t('auth.accept_title')} subtitle={t('auth.accept_subtitle')}>
      <Head title={t('auth.accept_title')} />

      <form onSubmit={submit} className="flex flex-col gap-5">
        <Field>
          <Label>{t('auth.new_password')}</Label>
          <Input
            type="password"
            autoComplete="new-password"
            autoFocus
            required
            value={form.data.password}
            onChange={(e) => form.setData('password', e.target.value)}
          />
          {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
        </Field>

        <Field>
          <Label>{t('auth.confirm_password')}</Label>
          <Input
            type="password"
            autoComplete="new-password"
            required
            value={form.data.password_confirmation}
            onChange={(e) => form.setData('password_confirmation', e.target.value)}
          />
          {errors.password_confirmation && <ErrorMessage>{errors.password_confirmation}</ErrorMessage>}
        </Field>

        <Button type="submit" color="brand" disabled={form.processing} className="w-full">
          {t('auth.set_password')}
        </Button>
      </form>
    </AuthShell>
  )
}
